export default __webpack_public_path__ + "static/hong-kong-at-night-cf3cfbad6595c180457d9cae35628a7d.jpg";